export default ({ post, checkStatus }) => ({
  updateOnSiteMessageStatus: (messagesStatus) =>
    post("universe/v1/on_site_message_tracks", {
      body: {
        onSiteMessageTracks: messagesStatus,
      },
    }).then((response) => checkStatus({ response, method: "POST" })),
});
